import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import useIsMobile from "../hooks/useIsMobile"

export default function Contact() {
    const isMobile = useIsMobile()

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <section style={{ maxWidth: 800, margin: "0 auto", padding: isMobile ? "32px 20px 80px" : "60px 24px 120px" }}>
                <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#6B7280", textDecoration: "none", fontSize: 15, fontWeight: 500, marginBottom: isMobile ? 24 : 40 }}>
                    ← Back to home
                </Link>
                <h1 style={{ fontSize: isMobile ? 36 : 52, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 16px" }}>
                    Contact
                </h1>
                <p style={{ fontSize: isMobile ? 18 : 24, fontWeight: 700, color: "#111827", margin: "0 0 16px" }}>
                    We'd love to hear from you.
                </p>
                <p style={{ fontSize: isMobile ? 16 : 18, color: "#6B7280", lineHeight: 1.8, marginBottom: isMobile ? 32 : 48 }}>
                    Whether you have feedback, partnership ideas, quiz suggestions, or questions about Qwiztime, feel free to reach out.
                </p>

                <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: isMobile ? 32 : 48 }}>
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: 16, padding: isMobile ? 24 : 32 }}>
                        <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 10px" }}>General Inquiries</h2>
                        <a href="mailto:listener@qwiztime.ai" style={{ color: "#2563EB", fontWeight: 600, fontSize: 17, textDecoration: "none" }}>
                            listener@qwiztime.ai
                        </a>
                    </div>

                    <div style={{ border: "1px solid #E5E7EB", borderRadius: 16, padding: isMobile ? 24 : 32 }}>
                        <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 10px" }}>Privacy & Data Questions</h2>
                        <a href="mailto:privacy@qwiztime.ai" style={{ color: "#2563EB", fontWeight: 600, fontSize: 17, textDecoration: "none" }}>
                            privacy@qwiztime.ai
                        </a>
                    </div>

                    <div style={{ background: "#F9FAFB", borderRadius: 16, padding: isMobile ? 24 : 32 }}>
                        <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 10px" }}>Response Time</h2>
                        <p style={{ fontSize: 16, color: "#6B7280", margin: 0, lineHeight: 1.7 }}>
                            We typically respond within 2–5 business days.
                        </p>
                    </div>
                </div>

                <div style={{ borderTop: "3px solid #2563EB", paddingTop: 36 }}>
                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "0 0 16px" }}>About Qwiztime</h2>
                    <p style={{ fontSize: isMobile ? 16 : 18, color: "#6B7280", lineHeight: 1.8, margin: 0 }}>
                        Qwiztime is building focused diagnostic quizzes designed to help learners, students, and professionals better understand skill gaps and readiness through practical assessments and clear explanations.
                    </p>
                </div>
            </section>
            <Footer />
        </div>
    )
}
